/**
 * Services index - provides unified service factory
 */

import { BaseApiClient } from '../core/base-client';
import { WorkspaceService, createWorkspaceService } from './workspace.service';
import { PropertyService, createPropertyService } from './property.service';
import { BookingService, createBookingService } from './booking.service';
import { PricingService, createPricingService } from './pricing.service';
import { PlacesService, createPlacesService } from './places.service';
import { AmenityService, createAmenityService } from './amenity.service';

// Export all service classes
export { WorkspaceService } from './workspace.service';
export { PropertyService } from './property.service';
export { BookingService } from './booking.service';
export { PricingService } from './pricing.service';
export { PlacesService } from './places.service';
export { AmenityService } from './amenity.service';

// Export all factory functions
export { createWorkspaceService } from './workspace.service';
export { createPropertyService } from './property.service';
export { createBookingService } from './booking.service';
export { createPricingService } from './pricing.service';
export { createPlacesService } from './places.service';
export { createAmenityService } from './amenity.service';

/**
 * Unified services interface
 */
export interface ApiServices {
  workspace: WorkspaceService;
  property: PropertyService;
  booking: BookingService;
  pricing: PricingService;
  places: PlacesService;
  amenity: AmenityService;
}

/**
 * Factory function to create all services with a unified API client
 */
export function createApiServices(client: BaseApiClient): ApiServices {
  return {
    workspace: createWorkspaceService(client),
    property: createPropertyService(client),
    booking: createBookingService(client),
    pricing: createPricingService(client),
    places: createPlacesService(client),
    amenity: createAmenityService(client),
  };
} 